/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// src/components/WinRateCalculator/ResultsDisplay.jsx
import * as React from "react";

export default function ResultsDisplay({ pMin, contributions, averageRR }) {
  // colour for the main hit-rate
  const colorClass =
    pMin < 60 ? "text-success" : // Using theme's success color
    pMin < 80 ? "text-warning" : // Using theme's warning color
    "text-destructive"; // Using theme's destructive color

  return (
    <div className="mt-4 text-textPrimary"> {/* Default text color for the container */}
      {/* Main Required Hit-Rate */}
      <h2 className={`text-2xl font-semibold ${colorClass}`}>
        Required Hit-Rate: {pMin.toFixed(1)} %
      </h2>

      {/* Average R:R */}
      {averageRR !== undefined && (
        <h2 className="text-xl font-semibold mt-2 text-info"> {/* Using theme's info color (or could be primary/secondary) */}
          Average R:R (Win): {averageRR.toFixed(2)} R
        </h2>
      )}

      {/* Breakdown Section */}
      <section className="mt-6">
        <h3 className="text-lg font-medium text-textPrimary">Breakdown by Run-to Targets</h3> {/* Title color */}
        <ul className="mt-3 space-y-2 text-sm text-textPrimary"> {/* List item default text color */}
          {contributions.map(({ label, q, profit, contrib }) => {
            // unconditional % of all trades that reach TPᵢ
            const absPct = (pMin * q) / 100;
            return (
              <li key={label} className="flex justify-between items-baseline">
                <div className="space-y-0.5">
                  <div>
                    <span className="font-medium text-textPrimary">{label}</span>:{" "} {/* Ensure span text color */}
                    {q}% of winners × {profit.toFixed(2)} R ={" "}
                    <span className="font-semibold text-textPrimary">{contrib.toFixed(2)} R</span> {/* Ensure span text color */}
                  </div>
                  <div className="text-xs text-textSecondary"> {/* Muted text color */}
                    → {absPct.toFixed(1)}% of all trades hit {label}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
}
